import React from "react";
import { Inbox } from "lucide-react";
import { Button } from "./ui/button";

export function EmptyState({ icon: Icon = Inbox, title, hint, actionLabel, onAction, testid = "empty-state" }) {
  return (
    <div className="lb-card p-8 flex flex-col items-center text-center" data-testid={testid}>
      <span className="w-12 h-12 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-[hsl(var(--muted-foreground))] mb-3">
        <Icon size={22} />
      </span>
      <p className="font-semibold text-sm mb-1">{title}</p>
      {hint && <p className="text-xs text-[hsl(var(--muted-foreground))] max-w-xs mb-4 leading-relaxed">{hint}</p>}
      {actionLabel && onAction && (
        <Button onClick={onAction} data-testid={`${testid}-cta`}
          className="rounded-full h-10 px-5 bg-gradient-to-r from-primary to-neon text-white lb-glow-btn text-sm">
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
